/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'

const QuickLinks: FC = () => (
  <div className='menu menu-sub menu-sub-dropdown menu-column w-lg-400px' data-kt-menu='true'>
    <div
      className='d-flex flex-column flex-center bgi-no-repeat rounded-top  py-5'
      style={{backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`}}
    >
      <h3 className='text-white fw-bold mb-3'>Acesso Rápido</h3>

      {/* <span className='badge bg-primary py-2 px-3'>25 pending tasks</span> */}
    </div>

    <div className='row g-0'>
      <div className='col-12'>
        <Link to='/sga'>
          <p
            className='
                d-flex flex-column
                flex-center h-100
                p-6 bg-hover-light
                border-end
                border-bottom
                '
          >
            <img
              className='w-25 h-30 mb-2'
              src={toAbsoluteUrl('/media/subsystem/logo_sga.svg')}
              alt='metronic'
            />
            <span className='fs-5 fw-bold text-gray-800 mb-0'>SGA</span>
            <span className='fs-7 text-center text-gray-600'>Sistema Gerenciamento Ambiental</span>
          </p>
        </Link>
      </div>

      {/* <div className='col-6'>
        <Link to='/sgt'>
          <p className='d-flex flex-column flex-center h-100 p-6 bg-hover-light border-bottom'>
            <img
              className='w-50 h-30 mb-2'
              src={toAbsoluteUrl('/media/subsystem/logo_sgt.svg')}
              alt='metronic'
            />
            <span className='fs-5 fw-bold text-gray-800 mb-0'>SGT</span>
            <span className='fs-7 text-center text-gray-600'>
              Sistema Gerenciamento Territorial
            </span>
          </p>
        </Link>
      </div> */}
      {/* 
      <div className='col-6'>
        <Link to='/sgo'>
          <p className='d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end'>
            <img
              className='w-50 h-30 mb-2'
              src={toAbsoluteUrl('/media/subsystem/logo_sgo.svg')}
              alt='metronic'
            />
            <span className='fs-5  fw-bold text-gray-800 mb-0'>SGO</span>
            <span className='fs-7 text-center text-gray-600'>
              Sistema Gerenciamento Operacional
            </span>
          </p>
        </Link>
      </div>

      <div className='col-6'>
        <Link to='/sgc'>
          <p className='d-flex flex-column flex-center h-100 p-6 bg-hover-light'>
            <img
              className='w-50 h-30 mb-2'
              src={toAbsoluteUrl('/media/subsystem/logo_sgc.svg')}
              alt='metronic'
            />
            <span className='fs-5 fw-bold text-gray-800 mb-0'>SGC</span>
            <span className='fs-7 text-center text-gray-600'>Sistema Gerenciamento de Coleta</span>
          </p>
        </Link>
      </div> */}
    </div>

    <div className='py-2 text-center border-top'>
      <Link to='/' className='btn btn-color-gray-600 btn-active-color-primary'>
        Ver Todos <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
      </Link>
    </div>
  </div>
)

export {QuickLinks}
